export function getSocialMediaShareUrl(id) {
  let sharingUrl = window.location.href;

  if (id) {
    const hash = window.location.hash;
    const regex = /^#\/([\w-]+)\/([\w-]+)$/;  // format is #/something/id
    const match = hash.match(regex);
    const isIdIncluded = match && match[2]

    if (!isIdIncluded) {
      sharingUrl += '/' + id;
    }
  }
  return sharingUrl;
};